module.exports = __webpack_public_path__ + "files/1de766659bdc883d29ee528ff654fbc4.png";